// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"eb6b0495","821":"02d52382"}[chunkId] + ".chunk.js";
};